import { pdfjs } from "react-pdf";

const MIN_CHARS = 20;

export async function pdfHasExtractableText(source: Blob | ArrayBuffer | ArrayBufferView, samplePages = 4): Promise<boolean> {
   const data: ArrayBuffer = source instanceof Blob
      ? await source.arrayBuffer()
      : ArrayBuffer.isView(source)
         ? source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength) as ArrayBuffer
         : source;
   const pdf = await pdfjs.getDocument({ data }).promise;
   const pagesToRead = Math.min(samplePages, pdf.numPages);
   let collected = "";
   for (let pageNumber = 1; pageNumber <= pagesToRead; pageNumber += 1) {
      const page = await pdf.getPage(pageNumber);
      const content = await page.getTextContent();
      collected += content.items
         .map((item) => ("str" in item ? String(item.str || "") : ""))
         .join(" ");
      if (collected.replace(/\s+/g, "").length >= MIN_CHARS) {
         return true;
      }
   }
   return collected.replace(/\s+/g, "").length >= MIN_CHARS;
}
